import parse from 'html-react-parser';

import { Box, IconButton } from '@bcp-nextgen-dx-component-factory/design-system';
import { BannerProps, Close } from '@components';
import { UIHelper } from '@helpers';

import { AppComposableTypography } from '../_cf';
import { ImageWithBackground } from '../imageWithBackground';
import { DEFAULT_BANNER_BACKGROUND, PRIMARY_DARK_COLOR_TOKEN, useBannerHelper } from './banner.helper';

export const BannerMobile = ({ isCollapsed }: BannerProps) => {
	const { t, handleCloseClick, background, LogoIcon, exit } = useBannerHelper();
	const mobileIcon = t('components.banner.icon.mobile');

	return (
		<Box styles={{ flexDirection: 'column', position: 'relative' }}>
			{exit.visible && <CloseIcon onClick={() => handleCloseClick(exit.url)} />}
			<Box
				styles={{
					position: 'relative',
					flexDirection: 'column',
					padding: UIHelper.rem(40, 24, 32),
					maxHeight: isCollapsed ? UIHelper.rem(104) : UIHelper.rem(300),
					transition: 'max-height 0.3s ease-out',
				}}
			>
				<ImageWithBackground imageSrc={background.mobile} background={DEFAULT_BANNER_BACKGROUND} />

				<Box
					styles={{
						flex: 1,
						flexDirection: 'column',
						justifyContent: 'space-between',
						maxWidth: UIHelper.rem(462),
					}}
				>
					<Box styles={{ flexDirection: 'column' }}>
						<LogoIcon width={105} height={32} />

						<Box
							styles={{
								flexDirection: 'column',
								marginTop: UIHelper.rem(40),
							}}
						>
							{mobileIcon && <Box styles={{ marginBottom: '16px' }}>{parse(mobileIcon)}</Box>}

							<AppComposableTypography
								colorToken={PRIMARY_DARK_COLOR_TOKEN}
								text={t('components.banner.title.mobile')}
							/>
						</Box>
					</Box>
				</Box>
			</Box>
		</Box>
	);
};

const CloseIcon = ({ onClick }: { onClick?: () => void }) => (
	<Box
		styles={{
			position: 'absolute',
			top: UIHelper.rem(40),
			right: UIHelper.rem(24),
			zIndex: 1,
		}}
	>
		<IconButton size="small" appearance="primary-500" iconSource={Close} onPress={onClick} />
	</Box>
);
